var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8 8.95C5.75 8.95 5.7 8.9 5.65 8.85L3.65 6.85C3.45 6.65 3.45 6.35 3.65 6.15C3.85 5.95 4.15 5.95 4.35 6.15L5.5 7.3V1.5C5.5 1.2 5.7 1 6 1C6.3 1 6.5 1.2 6.5 1.5V7.3L7.65 6.15C7.85 5.95 8.15 5.95 8.35 6.15C8.55 6.35 8.55 6.65 8.35 6.85L6.35 8.85C6.325 8.875 6.3 8.8875 6.275 8.9C6.25 8.9125 6.225 8.925 6.2 8.95C6.15 9 6.05 9 6 9C5.95 9 5.85 9 5.8 8.95ZM11 10.5V9C11 8.7 10.8 8.5 10.5 8.5C10.2 8.5 10 8.7 10 9V10.5C10 10.8 9.8 11 9.5 11H2.5C2.2 11 2 10.8 2 10.5V9C2 8.7 1.8 8.5 1.5 8.5C1.2 8.5 1 8.7 1 9V10.5C1 11.35 1.65 12 2.5 12H9.5C10.35 12 11 11.35 11 10.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_15205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 10,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8 8.95C5.75 8.95 5.7 8.9 5.65 8.85L3.65 6.85C3.45 6.65 3.45 6.35 3.65 6.15C3.85 5.95 4.15 5.95 4.35 6.15L5.5 7.3V1.5C5.5 1.2 5.7 1 6 1C6.3 1 6.5 1.2 6.5 1.5V7.3L7.65 6.15C7.85 5.95 8.15 5.95 8.35 6.15C8.55 6.35 8.55 6.65 8.35 6.85L6.35 8.85C6.325 8.875 6.3 8.8875 6.275 8.9C6.25 8.9125 6.225 8.925 6.2 8.95C6.15 9 6.05 9 6 9C5.95 9 5.85 9 5.8 8.95ZM11 10.5V9C11 8.7 10.8 8.5 10.5 8.5C10.2 8.5 10 8.7 10 9V10.5C10 10.8 9.8 11 9.5 11H2.5C2.2 11 2 10.8 2 10.5V9C2 8.7 1.8 8.5 1.5 8.5C1.2 8.5 1 8.7 1 9V10.5C1 11.35 1.65 12 2.5 12H9.5C10.35 12 11 11.35 11 10.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_15205)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    fill: "#131826"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.188f24feb816c21fc184eee6547f3a8a.svg";
export { ForwardRef as ReactComponent };